<template>
  <div>
    <basic-container id="examine20211201">
      <el-form :inline="true" ref="form" :model="form">
        <el-row :gutter="20">
          <el-col span="6">
            <el-form-item label="项目名称" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.projectId"
                placeholder="请选择项目"
                size="small"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="开始时间" style="width: 100%; display: flex">
              <!-- <el-input
                      v-model="searchform.timeStart"
                      placeholder="请输入开始时间"
                    ></el-input> -->
              <div style="width: 100%; flex: 1">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.beginDate"
                  value-format="yyyy-MM-dd HH-mm-ss"
                  type="datetime"
                  placeholder="选择开始时间"
                >
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="结束时间" style="width: 100%; display: flex">
              <!-- <el-input
                      v-model="searchform.timeEnd"
                      placeholder="请输入结束时间"
                    ></el-input> -->
              <div style="width: 100%; flex: 1">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.endDate"
                  value-format="yyyy-MM-dd HH-mm-ss"
                  type="datetime"
                  placeholder="请输入结束时间"
                >
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col span="6" style="text-align:right">
            <el-form-item>
              <el-button type="primary" @click="onSubmit" size="small" icon="el-icon-search">搜 索</el-button>
              <el-button type="primary" @click="searchReset" size="small" icon="el-icon-delete">清 空</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params"/>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import urlSettings from '@/config/url-settings';
import WebReport from '@/components/web-report';
import {getProjectList} from "@/api/crmedical/report/examine.js";
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      url: '',
      form: {
        projectId: [],
      },
      projectList: [],
      oldOptions: [],
      params: {
        reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/examine.cpt',
        //  reportlet: 'oweSummary.cpt',
      },
      dic: [],
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.projectId = this.form.projectId;
          if(!this.form.beginDate){
            this.params.beginDate ='';
          }else{
            this.params.beginDate = this.form.beginDate;
          }
          if(!this.form.endDate){
            this.params.endDate ='';
          }else{
            this.params.endDate = this.form.endDate;
          }


          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    searchReset(){
      this.form.beginDate = '';
      this.form.endDate = '';
      this.onSubmit();
    },

    initPropertyList() {
      // periodList
      var that = this;

      getProjectList({}).then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.form.projectId = this.projectIdList[0].id;
        }
        if (this.$route.query.id) {
          setTimeout(() => {
            this.onLoad_();
          });
        } else {
          setTimeout(() => {
            this.onLoad();
          });
        }
        var reportUrl = urlSettings.BASE_REPORT_URL;

        this.url = reportUrl.split('?')[0];
        //this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=examine.cpt';

        this.params.projectId =  this.form.projectId;

      setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {
    this.initPropertyList();
  },
};
</script>

<style>
#examine20211201 .el-input__icon{
  line-height: 32px;
}

#examine20211201 .el-form-item__content{
  flex-grow: 1;
  flex-shrink: 1;
}

#examine20211201 .el-form-item__label{
  flex-grow: 0;
  flex-shrink: 0;
}

#examine20211201 .is-required{
  display: flex;
}


</style>
